import { render, staticRenderFns } from "./pop-img.vue?vue&type=template&id=79ea8566&scoped=true"
import script from "./pop-img.vue?vue&type=script&lang=js"
export * from "./pop-img.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ea8566",
  null
  
)

export default component.exports